import React, { useState, useContext, useEffect } from "react";
import cn from "classnames";
import styles from "./NotificationForm.module.sass";
import Card from "../../../components/Card";
import File from "../../../components/File";
import './Variations.css'
import TextInput from "../../../components/TextInput";
import { createNotification, getCustomer, getSellers, uploadFile } from "../../../Firebase/firebaseDatabase";
import { GlobalState } from "../../../App";
import LoadingDialog from "../../../LoadingScreen/LoadingDialog";
import { randomNumGenerator, validate_if_not_empty } from "../../../utils/extensions";
import axios from "axios";
import PopupScreen from "./PopupScreen/PopupScreen";
import { EmailOtpTemplate } from "./EmailTemplate";
// import LoadingIndicator from "../../../LoadingScreen/LoadingIndicator";


const NotificationForm = ({ className }) => {

  const {
    isClicked, setIsClicked,
    isActionComplete, setIsActionComplete, setShowModalView, otpValidation, setOtpValidation,
    showModalView, userData
  } = useContext(GlobalState)

  const [image, setImage] = useState()
  const [description, setDescription] = useState()
  const [title, setTitle] = useState()

  const [activeOtpScreen, setActiveOtpScreen] = useState(false)

  const [randomNumbers, setRandomNumbers] = useState()

  const handleChangeFiles = () => {
    const id = document.getElementById('notificationCoverImg');
    setImage(id.files[0])
  }

  const notificationDetailsObj = {
    id: '',
    dateCreated: '',
    dateEdited: '',
    status: '',
    title: title ?? '',
    description: description ?? '',
    image: image ?? ''
  }

  useEffect(() => {
    setIsClicked(false)
    setIsActionComplete(false)
    setShowModalView(false)
    setOtpValidation('')
  }, []);

  useEffect(() => {
    // setIsActionComplete(false)
  }, [isClicked, isActionComplete]);

  const uploadNotification = async () => {
    await createNotification(notificationDetailsObj).then(res => {
    })
  }

  const validateAllFields = () => {
    if (validate_if_not_empty(title, "notficationTitleErrId") &&
      validate_if_not_empty(description, "notificationDescEnErrId") &&
      validate_if_not_empty(image, "notficationImageErrId")) {
      return true
    } else {
      setIsClicked(false)
      return false
    }
  }

  const sendNotification = async (fcm) => {
    const body = {
      "to": fcm,
      "notification": {
        "body": description ?? '',
        "title": title ?? ''
      }
    }

    await axios.post("https://fcm.googleapis.com/fcm/send", body, {
      headers: {
        "Authorization": "key=AAAAgP9ZCiQ:APA91bF0ZOldenMP_Tl4luWqhp70Mr5C46lMZ57x8xtP2hpe08PnNZ0Qm874MB3j8NWV6_qEQQwBON4RcKqBXLDr1-1LLhIXxZxR-TSM539h3V0YWeaB4mfEcIDCT4yo3w7K1wzsqTM9",
        " Content-Type": "application/json"
      },
    }).then((res) => {
      console.log("sent notification: ", res)
    }).catch((err) => {
      console.log("Failed to send notification:", err)
    })
  }

  const sendEmail = (otp) => {
    var data = JSON.stringify({
      "sender": {
        "name": "SmSm",
        "email": "no-reply@smsm.sa"
      },
      "to": [
        {
          "email": userData.email,
        }
      ],
      "subject": "SmSm Verification OTP",
      "htmlContent": EmailOtpTemplate(otp, title, description)
    });

    var config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://api.sendinblue.com/v3/smtp/email',
      headers: {
        'api-key': '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',
        'Content-Type': 'application/json'
      },
      data: data
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  const senderVerification = () => {
    const otp = randomNumGenerator(6)
    setRandomNumbers(otp)

    sendEmail(otp, title, description)

  }

  const InitateSendNotification = async () => {
    await uploadFile(notificationDetailsObj?.image, "notification").then(url => {
      notificationDetailsObj.image = url;
      uploadNotification()
    }
    )
    getCustomer().then(res => {
      res.forEach((customerData, index) => {
        sendNotification(customerData?.fcmToken)
        if (res.length - 1 === index) {
          setIsActionComplete(true)
          setIsClicked(false)
        }
      });
    })
  }

  useEffect(() => {
    if (otpValidation === 'VALID') {
      console.log('OTP verification is successful!')
      setIsClicked(true)
      InitateSendNotification()
    }
    // if (otpValidation === 'INVALID') {
    //   console.log("invalid otp")
    //   alert("Invalid OTP")
    // }

  }, [otpValidation])

  return (
    <Card
      className={cn(styles.card, className)}
      title="Create Notification"
      classTitle="title-green"
      head={
        <div style={{
          display: 'flex',
          gap: '12px'
        }}>

          <button
            onClick={async () => {
              // setIsClicked(true)
              const isValidateAllFields = validateAllFields()
              if (isValidateAllFields) {
                senderVerification()
                setActiveOtpScreen(true)
                setShowModalView(true)

              }
            }}
            className={cn("button", styles.button)} >
            <span>Send</span>
          </button>
        </div>

      }
    >
      {
        isClicked ?
          !isActionComplete ?
            <LoadingDialog /> : window.location.href = "/notifications"
          : <></>
      }

      {/* {
        activeOtpScreen ?  */}
      <PopupScreen otp={randomNumbers} />
      {/* //   :
      //     <></>
      // } */}



      <div className={styles.description}>

        <div className={styles.fieldset}>

          <div className={`${styles.fieldContainer}`}>
            <TextInput
              className={styles.field}
              classInput={styles.fieldInput}
              label="Title"
              name="notificationTitle"
              type="text"
              onChange={(e) => { setTitle(e.target.value) }}
              value={title}
            />
            <p className={styles.errField} id="notficationTitleErrId"></p>

          </div>
        </div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }} className={styles.fieldContainer}>
          <label className={styles.label}>Description</label>
          <textarea
            placeholder="Type here.."
            className={styles.descriptionField}
            onChange={(e) => { setDescription(e.target.value) }}
            value={description}
          />
          <p className={styles.errField} id="notificationDescEnErrId"></p>
        </div>


        <div className={styles.image_section}>

          <div className={styles.files}>
            <File
              classInput={styles.imageInput}
              className={styles.imageField}
              classInputWraper={styles.imageFieldWrapper}
              title={
                image?.name !== '' && image?.name !== undefined ?
                  image?.name
                  : "Click or drop image"
              }
              id={`notificationCoverImg`}
              label="Cover image"
              onChange={() => handleChangeFiles()}
            // url={isEditForm ? image : ''}
            />
            <p className={styles.errField} id="notficationImageErrId"></p>

          </div>

        </div>

      </div>
    </Card>
  );
};

export default NotificationForm;
